"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _rpdfYoga = _interopRequireDefault(require("@surge-global-engineering/rpdf-yoga"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Set justify content attribute to node's Yoga instance
 *
 * @param {String} justify content value
 * @param {Object} node instance
 * @return {Object} node instance
 */
var setJustifyContent = function setJustifyContent(value) {
  return function (node) {
    var yogaNode = node._yogaNode;
    if (!R.isNil(value) && yogaNode) {
      var yogaValue = R.cond([[R.equals('center'), R.always(_rpdfYoga.default.JUSTIFY_CENTER)], [R.equals('flex-end'), R.always(_rpdfYoga.default.JUSTIFY_FLEX_END)], [R.equals('space-between'), R.always(_rpdfYoga.default.JUSTIFY_SPACE_BETWEEN)], [R.equals('space-around'), R.always(_rpdfYoga.default.JUSTIFY_SPACE_AROUND)], [R.equals('space-evenly'), R.always(_rpdfYoga.default.JUSTIFY_SPACE_EVENLY)], [R.T, R.always(_rpdfYoga.default.JUSTIFY_FLEX_START)]])(value);
      yogaNode.setJustifyContent(yogaValue);
    }
    return node;
  };
};
var _default = exports.default = setJustifyContent;